import { iconsMap } from "./iconsMap";
import type { IconName } from "./iconsMap";

export type IconProps = {
  name: IconName;
  size?: number | string;
  color?: string;
  height?: number | string;
  width?: number | string;
  preserveAspectRatio?: string;
};

export const Icon = ({
  name,
  size = 20,
  color = "black",
  height,
  width,
  preserveAspectRatio,
}: IconProps) => {
  const Svg = iconsMap[name];
  if (!Svg) return null;
  return (
    <Svg
      width={width || size}
      height={height || size}
      style={{ color }}
      preserveAspectRatio={preserveAspectRatio}
    />
  );
};
